import { createReducer, on } from '@ngrx/store';
import { PaginatedData } from '@base/wrappers/paginated-data';
import {
  UserPlansSummaryFilters,
  UserPlansSummaryModel,
} from '@domain/models/user.model';
import { UsersPlansSummaryActions } from '../actions/users-plans-summary.actions';

export interface UsersPlansSummaryState {
  pagination: PaginatedData<any>;
  users: UserPlansSummaryModel[];
  filters: UserPlansSummaryFilters;
  error: any;
  usersSelected: Set<string>;
  usersLoaded: boolean;
}

export const initialState = (): UsersPlansSummaryState => {
  return {
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      totalPages: 0,
      totalRecords: 0,
      hasPrevious: false,
      hasNext: false,
    },
    users: [],
    filters: {},
    error: '',
    usersSelected: new Set(),
    usersLoaded: false,
  }
};

export const usersPlansSummaryReducer = createReducer(
  initialState(),
  on(UsersPlansSummaryActions.clearUsers, (_) => (initialState())),
  on(
    UsersPlansSummaryActions.loadUsersSuccess,
    (state, { pagination }) => ({
      ...state,
      pagination: pagination ?? state.pagination,
      users: pagination?.data ?? [],
      usersLoaded: true,
    })
  ),
  on(UsersPlansSummaryActions.loadUsersFailure, (state, { error }) => ({
    ...initialState(),
    error: error,
  })),
  on(UsersPlansSummaryActions.setFiltersAndPaginatedData, (state, data) => ({
    ...state,
    filters: {
      ...state.filters,
      ...data.filters
    },
    pagination: {
      ...state.pagination,
      ...data.paginatedData
    },
    usersLoaded: false,
  })),
  on(UsersPlansSummaryActions.setSelectUser, (state, { id, isSelected}) => {
    if (isSelected) state.usersSelected.add(id)
    else state.usersSelected.delete(id);

    return state;
  })
);
